import { render, staticRenderFns } from "./ExcursionSliderComponent.vue?vue&type=template&id=2964a600&scoped=true&"
import script from "./ExcursionSliderComponent.vue?vue&type=script&lang=js&"
export * from "./ExcursionSliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExcursionSliderComponent.vue?vue&type=style&index=0&id=2964a600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964a600",
  null
  
)

export default component.exports